import { PluginType } from '@Generated/back-office-client/src'

export type PluginSlot = {
  type: PluginType
  label: string
  refId?: string
}

export const PLUGIN_SLOTS: PluginSlot[] = [
  {
    type: PluginType.PLAYER_AUTH,
    label: 'Player Auth',
  },
  {
    type: PluginType.PLAYER_DETAILS,
    label: 'Player Details',
  },
  {
    type: PluginType.PLAYER_ELIGIBILITY,
    label: 'Player Eligibility',
  },
  {
    type: PluginType.PLAYER_POINTS,
    label: 'Player Points',
  },
  {
    type: PluginType.TICKET_SCAN,
    label: 'Ticket Scan',
  },
  {
    type: PluginType.TICKET_SCAN_DISPLAY,
    label: 'Ticket Scan Display',
  },
  {
    type: PluginType.REWARD_CATALOG,
    label: 'Reward Catalog',
  },
  {
    type: PluginType.REWARD_ASSIGNMENT,
    label: 'Reward Assignment — Entries',
    refId: 'ENTRIES',
  },
  {
    type: PluginType.REWARD_ASSIGNMENT,
    label: 'Reward Assignment — In Store',
    refId: 'IN_STORE',
  },
  {
    type: PluginType.REWARD_ASSIGNMENT,
    label: 'Reward Assignment — Online',
    refId: 'ONLINE',
  },
  {
    type: PluginType.REWARD_ASSIGNMENT,
    label: 'Reward Assignment — Cash',
    refId: 'CASH',
  },
]
